import Button from "@app/components/button";
import GradientContainer from "@app/components/gradient/gradient-container";
import TextGradient from "@app/components/gradient/gradient-text";
import { useState } from "react";

/* eslint-disable @next/next/no-img-element */
const DesktopHoaResidential = ({ inView7 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="flex flex-row-reverse">
      <div className="bg-background-mid-em flex items-center">
        <div
          className={`shadow-lg-light absolute bg-opacity-80  bg-light 
          w-[65%] xl:w-[60%] blur-content rounded-2xl p-6`}
          style={{
            visibility: inView7 ? 'visible' : 'hidden',
            transform: inView7 ? 'translateX(-150%)' : 'translateX(-158%)',
            // opacity: inView6 ? 0.9 : 0,
            transition: 'transform 500ms ease-in',
          }}
        >
          <div
            className={`flex flex-col ml-2 space-y-5
            ${isExpanded ? 'h-[490px] xl:h-[500px] xl-2:!h-[460px]' : 'h-[350px] xl:h-[360px] xl-2:!h-[340px] '}
             transition-[height] ease-out duration-500`}
          >
            <TextGradient>
              <p className="h2">07</p>
            </TextGradient>
            <p className="h4 xl:h3 text-background-primary-dark">HOAs & Residential</p>
            <div>
              <GradientContainer overrideClassName="w-[22%] h-2" />
            </div>
            <div className=" text-text-color-mid-em-light space-y-5">
              <p>
                SimpleWaste represents HOA and residential communities nationwide.
              </p>
              <p>
                Our technology platform provides complete program and service visibility for HOA
                leadership and individual residents.
                With SimpleWaste, you can manage your refuse services with ease.
              </p>
              {isExpanded && (
                <div>
                  <p>
                    Benefit from our procurement agency by allowing SimpleWaste to
                    represent your association.
                  </p>
                  <p>
                    We negotiate your vendor options while providing a single point
                    of contact experience through our sole source user interface.
                    Residents can log in to check a pick-up status, request additional service options,
                    or pay their bills.
                  </p>
                </div>
              )}
            </div>
            <div className="flex h-full items-end">
              <div>
                <Button onClick={() => setIsExpanded(!isExpanded)}>
                  {isExpanded ? 'Read less' : 'Read more'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <img
          src="/images/industries/hoa.jpg"
          alt="hoa"
          width={700}
          height={512}
        />
      </div>
    </div>
  )
};

export default DesktopHoaResidential;
